import { useAuthorizedFetch } from "../../core/data-access/useAuthorizedFetch";
import { WorkspaceResponse } from "./WorkspaceResponse";

export const useReportApi = () => {
    const { httpGet } = useAuthorizedFetch();

    const getReport = async (): Promise<WorkspaceResponse> => {
        return httpGet<WorkspaceResponse>(`${process.env.PUBLIC_URL}/power-bi-report`);
    };
    return { getReport };
};
